var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-size-4 content is-custom has-text-black-bis"},[_c('div',{staticClass:"card",class:{
      'mt-24px': _vm.$media.mobile,
      'mt-32px': _vm.$media.tablet,
      'mt-40px': _vm.$media.widescreen
    }},[_c('ui-box',[_c('prismic-rich-text',{attrs:{"field":_vm.prismicContent.welcome_message}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }